import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { SEXUAL_ACTIVITY_COLORS } from './SexualActivityChart';
import { colors, palette } from 'design';

const useStyles = createUseStyles({
  legendItem: {
    margin: '0px 12px 0px 0px',
    display: 'inline-flex',
    alignItems: 'center',
    color: colors.text.disabled,
    '& svg': {
      marginRight: 4,
    },
  },
  legendDot: {
    height: 8,
    width: 8,
    display: 'inline-block',
    marginRight: 4,
    borderRadius: '50%',
  },
});

const SexualActivityChartLegend: React.FC = () => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <div>
      <span className={styles.legendItem}>
        <CaretDownOutlined style={{ color: SEXUAL_ACTIVITY_COLORS.UNPROTECTED }} />
        {t('symptomTracking.survey.sexualActivity.UNPROTECTED')}
      </span>
      <span className={styles.legendItem}>
        <CaretUpOutlined style={{ color: SEXUAL_ACTIVITY_COLORS.PROTECTED }} />
        {t('symptomTracking.survey.sexualActivity.PROTECTED')}
      </span>
      <span className={styles.legendItem}>
        <div className={styles.legendDot} style={{ backgroundColor: palette.teal[500] }} />
        <div className={styles.legendDot} style={{ border: `1px solid ${palette.teal[900]}` }} />
        {t('symptomTracking.cycles.legend.fertile')}
      </span>
    </div>
  );
};
export default SexualActivityChartLegend;
